import { useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    // Use useRef to prevent double processing under StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.substring(1)).get("session_id");

    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }

    const processSession = async () => {
      try {
        const response = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        const user = response.data;
        setUser(user);

        // Clear the hash from URL
        window.history.replaceState(null, "", window.location.pathname);

        // Check if user was on a booking page before login
        const returnTo = sessionStorage.getItem('bookeasy_return_to');
        sessionStorage.removeItem('bookeasy_return_to');

        if (returnTo && returnTo.startsWith('/book/')) {
          navigate(returnTo, { replace: true });
        } else if (user.role === "business") navigate("/business", { replace: true });
        else if (user.role === "customer") navigate("/customer", { replace: true });
        else navigate("/role-select", { replace: true });
      } catch (error) {
        console.error("Auth callback error:", error);
        navigate("/", { replace: true });
      }
    };

    processSession();
  }, [navigate, setUser]);

  // Silent processing - no loading UI
  return null;
}
